if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-sticky-submit]');
        this.priceBox = this.querySelector('[data-sticky-price]');
        if (!this.button) return;

        this.onScroll = this.onScroll.bind(this);
        this.check = this.check.bind(this);
        this.ticking = false;

        this.button.addEventListener('click', () => {
          const target = this.getTarget();
          if (!target || target.disabled) return;
          target.click();
        });

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        document.addEventListener('product-info:loaded', this.check);

        this.mirror();
        const target = this.getTarget();
        if (target) {
          this.mutation = new MutationObserver(() => this.mirror());
          this.mutation.observe(target, { attributes: true, childList: true, subtree: true });
        }

        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            const fresh = data?.html?.querySelector(`#price-${this.dataset.sectionId}`);
            if (fresh && this.priceBox) this.priceBox.innerHTML = fresh.innerHTML;
            this.mirror();
          });
        }

        this.check();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('product-info:loaded', this.check);
        this.mutation?.disconnect();
        this.unsubscribe?.();
      }

      getTarget() {
        return document.getElementById(this.dataset.target);
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.check();
        });
      }

      // Mostra a barra sempre que o botão principal estiver fora da tela,
      // tanto acima (rolou para baixo) quanto abaixo (voltou para o topo).
      check() {
        const target = this.getTarget();
        if (!target) return this.toggle(false);
        const rect = target.getBoundingClientRect();
        const outOfView = rect.bottom < 0 || rect.top > window.innerHeight;
        this.toggle(outOfView && window.scrollY > 0);
      }

      mirror() {
        const target = this.getTarget();
        if (!target) return;
        const label = target.querySelector('span')?.textContent?.trim();
        if (label) this.button.querySelector('span').textContent = label;
        this.button.disabled = target.disabled;
        this.button.classList.toggle('button--secondary', target.disabled);
      }

      toggle(show) {
        if (show === this.shown) return;
        this.shown = show;
        clearTimeout(this.hideTimer);
        if (show) {
          this.hidden = false;
          requestAnimationFrame(() => this.classList.add('sticky-atc--visible'));
          document.body.classList.add('sticky-atc-active');
        } else {
          this.classList.remove('sticky-atc--visible');
          document.body.classList.remove('sticky-atc-active');
          this.hideTimer = setTimeout(() => {
            if (!this.shown) this.hidden = true;
          }, 300);
        }
      }
    }
  );
}
